import React from "react";
import styled from "styled-components";
import { Button } from "@material-ui/core";
import { auth, provider } from "../firebase";
import Logo from "../assets/Capture.JPG";
// import bg from "../assets/retro-furnish.png";
import bg from "../assets/asteroids.jpg";

function Login() {
  const signIn = (e) => {
    e.preventDefault();
    auth.signInWithPopup(provider).catch((error) => alert(error.message));
  };

  return (
    <LoginContainer>
      <LoginInnerContainer>
        <img src={Logo} alt="" />
        <h1>
          Sign in to <span>Groupify</span>
        </h1>
        <p>Chat & Chill</p>
        <Button onClick={signIn}>Sign in with Google</Button>
      </LoginInnerContainer>
    </LoginContainer>
  );
}

export default Login;

const LoginContainer = styled.div`
  height: 100vh;
  display: grid;
  place-items: center;
  background-image: url(${bg});
`;

const LoginInnerContainer = styled.div`
  padding: 100px;
  text-align: center;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  > img {
    object-fit: contain;
    height: 250px;
    margin-bottom: 40px;
  }
  > button {
    margin-top: 50px;
    text-transform: inherit !important;
    background-color: #0a8d48 !important;
    color: white;
    transition: all 0.4s;
  }

  > button:hover {
    /* opacity: 0.9; */
    box-shadow: 0 0 8px green;
  }
  > h1 > span {
    color: #dd3832;
  }
`;
